import { Theme } from '@material-ui/core';

/**
 * An abstract base class for all renderer classes.
 * It standardizes the constructor to accept a theme and a configuration object,
 * merging default and provided configurations.
 * @template TConfig The type of the configuration object for the renderer.
 */
export abstract class BaseRenderer<TConfig> {
  protected config: TConfig;
  protected theme: Theme;

  /**
   * @param theme The Material-UI theme object.
   * @param defaultConfig The default configuration for the renderer.
   * @param config A partial configuration object to override the defaults.
   */
  constructor(theme: Theme, defaultConfig: TConfig, config?: Partial<TConfig>) {
    this.theme = theme;
    this.config = { ...defaultConfig, ...config };
  }

  /**
   * The main render method for the renderer.
   * Must be implemented by subclasses.
   * @param ctx The canvas rendering context.
   * @param args Additional arguments required for rendering.
   */
  abstract render(ctx: CanvasRenderingContext2D, ...args: any[]): void;
}
